import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp } from "react-icons/fa";
import Loader from '../../../components/Loader/Loader';
import { Row, Col } from 'react-bootstrap';

import DateFild from '../../../components/DateTimePicker/DateFild';
import TimeFild from '../../../components/DateTimePicker/TimeFild';

import { postStatementFormStore } from '../../../apiservices/ApiServices';
import { statementFrmvalidationSchema } from '../../../schemas';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en';

const StatementForms = ({ details, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [localTime, setLocalTime] = useState(dayjs().format('HH:mm'));

    const prevStatementsLength = useRef(0);

    const emptyStatement = {
        id: '',
        startDate: dayjs().format('DD/MM/YYYY'),
        endDate: dayjs().format('DD/MM/YYYY'),
        startTime: localTime,
        endTime: localTime,
        totalDisruption: '',
        subjectMatterDetails: '',
        statemenatIssuer: {
            name: '',
            staffNumber: '',
            company: '',
            contactNumber: '',
            email: '',
            shiftTimings: '',
        },
        airsideLeadInspector: {
            staffName: '',
            staffNumber: '',
            contactNumber: '',
            date: dayjs().format('DD/MM/YYYY'),
            signature: '',
            leadInspector: '',
        },
        witnessStatementIssuer: {
            staffName: '',
            staffNumber: '',
            contactNumber: '',
            email: '',
            shiftTimings: '',
            date: dayjs().format('DD/MM/YYYY'),
            signature: '',
            statementIssuer: '',
        },
    };

    const mapApiDataToFormikValues = (apiData) => {
        return apiData?.statement_form?.map(item => ({
            id: item.id || '',
            startDate: item.start_date || '',
            endDate: item.end_date || '',
            startTime: item.start_time ? item.start_time.substring(0, 5) : '', // Extract HH:mm
            endTime: item.end_time ? item.end_time.substring(0, 5) : '',
            totalDisruption: item.total_duration || '',
            subjectMatterDetails: item.subject_matter_details || '',
            statemenatIssuer: {
                name: item.sid_name || '',
                staffNumber: item.sid_staff_no || '',
                company: item.sid_company || '',
                contactNumber: item.sid_contact_no || '',
                email: item.sid_email || '',
                shiftTimings: item.sid_shift_timing || '',
            },
            airsideLeadInspector: {
                staffName: item.ali_staff_name || '',
                staffNumber: item.ali_staff_no || '',
                contactNumber: item.ali_contact_no || '',
                date: item.ali_date || '',
                signature: item.ali_signature || '',
                leadInspector: item.ali_airside_lead_inspector || '',
            },
            witnessStatementIssuer: {
                staffName: item.wsi_staff_name || '',
                staffNumber: item.wsi_staff_no || '',
                contactNumber: item.wsi_contact_no || '',
                email: item.wsi_email || '',
                shiftTimings: item.wsi_shift_timing || '',
                date: item.wsi_date || '',
                signature: item.wsi_signature || '',
                statementIssuer: item.wsi_statement_issuer || '',
            }
        })) || [];
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        statements: [emptyStatement]
    });

    useEffect(() => {
        if (details?.statement_form?.length) {
            const prefill = mapApiDataToFormikValues(details);
            setFieldValue('statements', prefill);
        }
    }, [details]);

    const addStatement = () => {
        setFieldValue('statements', [...values.statements, { ...emptyStatement }]);
    };

    const removeStatement = (index) => {
        const updated = values.statements.filter((_, i) => i !== index);
        setFieldValue('statements', updated);
    };

    const transformFormValuesToPostData = (values) => {
        return {
            statements: values.statements.map((item) => ({
                id: item.id,
                incident_header_id: details.header_id, // replace dynamically if needed
                start_date: item.startDate,
                end_date: item.endDate,
                start_time: item.startTime,
                end_time: item.endTime,
                total_duration_disruption: item.totalDisruption,
                subject_matter_details: item.subjectMatterDetails,

                statement_issuer: {
                    name: item.statemenatIssuer.name,
                    staff_no: item.statemenatIssuer.staffNumber,
                    company: item.statemenatIssuer.company,
                    contact_no: item.statemenatIssuer.contactNumber,
                    email: item.statemenatIssuer.email,
                    shift_timings: item.statemenatIssuer.shiftTimings,
                },

                airside_lead_inspector: {
                    staff_name: item.airsideLeadInspector.staffName,
                    staff_no: item.airsideLeadInspector.staffNumber,
                    contact: item.airsideLeadInspector.contactNumber,
                    date: item.airsideLeadInspector.date,
                    signature: item.airsideLeadInspector.signature,
                    inspector_name: item.airsideLeadInspector.leadInspector,
                },

                witness_or_statement_issuer: {
                    staff_name: item.witnessStatementIssuer.staffName,
                    staff_no: item.witnessStatementIssuer.staffNumber,
                    contact_no: item.witnessStatementIssuer.contactNumber,
                    email: item.witnessStatementIssuer.email,
                    shift_timings: item.witnessStatementIssuer.shiftTimings,
                    date: item.witnessStatementIssuer.date,
                    signature: item.witnessStatementIssuer.signature,
                    issuer_name: item.witnessStatementIssuer.statementIssuer,
                },
            })),
        };
    };

    const postStatementFormStores = async (postdata) => {
        setLoadings(true);
        try {
            const res = await postStatementFormStore(postdata);
            toast.success(res.data.message);
            postUpdateData();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }
    };
    const formik = useFormik({
        iinitialValues: {
            preventingAction: [emptyStatement]
        },
        validationSchema: '',
        initialValues: initialFormikValues,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const postdata = transformFormValuesToPostData(values);
            await postStatementFormStores(postdata);
            console.log('postdata', postdata);
        },
    });
    const { values, handleSubmit, setFieldValue, errors, touched } = formik;

    const calculateDuration = (startDate, startTime, endDate, endTime) => {
        if (!startDate || !startTime || !endDate || !endTime) return '';

        const start = dayjs(`${startDate} ${startTime}`, 'DD/MM/YYYY HH:mm');
        const end = dayjs(`${endDate} ${endTime}`, 'DD/MM/YYYY HH:mm');

        if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
            return 'Invalid time range';
        }

        const diffMinutes = end.diff(start, 'minute');
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;

        let duration = '';
        if (hours > 0) duration += `${hours} hour${hours > 1 ? 's' : ''} `;
        if (minutes > 0) duration += `${minutes} minute${minutes > 1 ? 's' : ''}`;

        return duration.trim() || '0 minutes';
    };

    useEffect(() => {
        values.statements.forEach((_, index) => {
            const stmt = values.statements[index];
            const duration = calculateDuration(
                stmt.startDate,
                stmt.startTime,
                stmt.endDate,
                stmt.endTime
            );
            setFieldValue(`statements[${index}].totalDisruption`, duration);
        });

        prevStatementsLength.current = values.statements.length;
    }, [values.statements.length]);

    const handleDateTimeChange = (index, field, value) => {
        setFieldValue(`statements[${index}].${field}`, value);

        const stmt = values.statements[index];
        const duration = calculateDuration(
            field === 'startDate' ? value : stmt.startDate,
            field === 'startTime' ? value : stmt.startTime,
            field === 'endDate' ? value : stmt.endDate,
            field === 'endTime' ? value : stmt.endTime
        );

        setFieldValue(`statements[${index}].totalDisruption`, duration);
    };

    return (
        <>
            <div className="GroupList fieldset">
                <div className='toggle-button'>
                    <h2 className="listTitle">Statement</h2>
                    <div className='btnColaps'><FaChevronUp /></div>
                </div>
                <div className="subFilds">
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div id="statement" className="multiGrop">
                            {values.statements.map((statement, index) => (
                                <div key={index} className="fieldset mainFS">
                                    <div className="statetitle_btn">
                                        <h1 className="titles">Statement <span>{index + 1}</span></h1>
                                        <div className="addreovebtns">
                                            <button type="button" className="btn add-btn" onClick={addStatement}>+</button>
                                            {values.statements.length > 1 && (
                                                <button type="button" className="btn remove-btn" onClick={() => removeStatement(index)}>-</button>
                                            )}
                                        </div>
                                    </div>
                                    <div className='formsBox'>
                                        <Row>
                                            <Col md={6}>
                                                <div className="fieldset">
                                                    <h1>Date & Time</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Start Date</label>
                                                                    <div className='datetimes'>
                                                                        <DateFild
                                                                            value={statement.startDate}
                                                                            onChange={(date) => handleDateTimeChange(index, 'startDate', date)}
                                                                        //onChange={(date) => setFieldValue(`statements[${index}].startDate`, date)}
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.startDate &&
                                                                        touched?.statements?.[index]?.startDate && (
                                                                            <p className="errormsg">{errors.statements[index].startDate}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>End Date</label>
                                                                    <div className='datetimes'>
                                                                        <DateFild
                                                                            value={statement.endDate}
                                                                            onChange={(date) => handleDateTimeChange(index, 'endDate', date)}
                                                                        //onChange={(date) => setFieldValue(`statements[${index}].endDate`, date)}
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.endDate &&
                                                                        touched?.statements?.[index]?.endDate && (
                                                                            <p className="errormsg">{errors.statements[index].endDate}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Start Time</label>
                                                                    <div className='datetimes'>
                                                                        <TimeFild
                                                                            value={values.statements[index].startTime}
                                                                            onChange={(time) => handleDateTimeChange(index, 'startTime', time)}
                                                                            //onChange={(time) => setFieldValue(`statements[${index}].startTime`, time)}
                                                                            format="local"
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.startTime &&
                                                                        touched?.statements?.[index]?.startTime && (
                                                                            <p className="errormsg">{errors.statements[index].startTime}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>End Time</label>
                                                                    <div className='datetimes'>
                                                                        <TimeFild
                                                                            value={values.statements[index].endTime}
                                                                            onChange={(time) => handleDateTimeChange(index, 'endTime', time)}
                                                                            //onChange={(time) => setFieldValue(`statements[${index}].endTime`, time)}
                                                                            format="local"
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.endTime &&
                                                                        touched?.statements?.[index]?.endTime && (
                                                                            <p className="errormsg">{errors.statements[index].endTime}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={12}>
                                                                <div className="form-group">
                                                                    <label className="w50">Total Duration Disruption</label>
                                                                    <input type="text"
                                                                        name="totalDisruption"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.totalDisruption}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].totalDisruption`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.totalDisruption &&
                                                                        touched?.statements?.[index]?.totalDisruption && (
                                                                            <p className="errormsg">{errors.statements[index].totalDisruption}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="fieldset">
                                                    <h1>Statement Issuer Details</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Name</label>
                                                                    <input
                                                                        name="name"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.name}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.name`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.name &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.name && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.name}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Staff No.</label>
                                                                    <input
                                                                        name="staffNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.staffNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.staffNumber`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.staffNumber &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.staffNumber && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.staffNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Company</label>
                                                                    <input
                                                                        name="company"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.company}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.company`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.company &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.company && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.company}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Contact No.</label>
                                                                    <input
                                                                        name="contactNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.contactNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.contactNumber`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.contactNumber &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.contactNumber && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.contactNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Email</label>
                                                                    <input
                                                                        name="email"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.email}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.email`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.email &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.email && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.email}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Shift Timings</label>
                                                                    <input
                                                                        name="shiftTimings"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.statemenatIssuer.shiftTimings}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].statemenatIssuer.shiftTimings`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.statemenatIssuer?.shiftTimings &&
                                                                        touched?.statements?.[index]?.statemenatIssuer?.shiftTimings && (
                                                                            <p className="errormsg">{errors.statements[index].statemenatIssuer.shiftTimings}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="form-group">
                                        <label>Subject Matter Details</label>
                                        <textarea
                                            name="subjectMatterDetails"
                                            className="form-control"
                                            autoComplete='off'
                                            value={statement.subjectMatterDetails}
                                            onChange={(e) => setFieldValue(`statements[${index}].subjectMatterDetails`, e.target.value)}
                                        />

                                        {errors?.statements?.[index]?.subjectMatterDetails &&
                                            touched?.statements?.[index]?.subjectMatterDetails && (
                                                <p className="errormsg">{errors.statements[index].subjectMatterDetails}</p>
                                            )}
                                    </div>
                                    <div className="formsBox">
                                        <Row>
                                            <Col md={6}>
                                                <div className="fieldset">
                                                    <h1>Airside Lead Inspector</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Staff Name</label>
                                                                    <input
                                                                        name="staffName"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.airsideLeadInspector.staffName}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].airsideLeadInspector.staffName`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.staffName &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.staffName && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.staffName}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Staff No.</label>
                                                                    <input
                                                                        name="staffNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.airsideLeadInspector.staffNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].airsideLeadInspector.staffNumber`, e.target.value)}

                                                                    />
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.staffNumber &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.staffNumber && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.staffNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Contact</label>
                                                                    <input
                                                                        name="contactNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.airsideLeadInspector.contactNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].airsideLeadInspector.contactNumber`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.contactNumber &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.contactNumber && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.contactNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Date</label>
                                                                    <div className='datetimes'>
                                                                        <DateFild
                                                                            value={values.statements[index].airsideLeadInspector.date}
                                                                            onChange={(date) => setFieldValue(`statements[${index}].airsideLeadInspector.date`, date)}
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.date &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.date && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.date}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={12}>
                                                                <div className="form-group">
                                                                    <label>Signature</label>
                                                                    <input
                                                                        name="signature"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.airsideLeadInspector.signature}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].airsideLeadInspector.signature`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.signature &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.signature && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.signature}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={12}>
                                                                <div className="form-group">
                                                                    <label>Airside Lead Inspector</label>
                                                                    <input
                                                                        name="leadInspector"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.airsideLeadInspector.leadInspector}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].airsideLeadInspector.leadInspector`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.airsideLeadInspector?.leadInspector &&
                                                                        touched?.statements?.[index]?.airsideLeadInspector?.leadInspector && (
                                                                            <p className="errormsg">{errors.statements[index].airsideLeadInspector.leadInspector}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="fieldset">
                                                    <h1>Witness / Statement Issuer</h1>
                                                    <div className="formsBox">
                                                        <Row>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Staff Name</label>
                                                                    <input
                                                                        name="staffName"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.staffName}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.staffName`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.staffName &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.staffName && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.staffName}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Staff No.</label>
                                                                    <input
                                                                        name="staffNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.staffNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.staffNumber`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.staffNumber &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.staffNumber && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.staffNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Contact</label>
                                                                    <input
                                                                        name="contactNumber"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.contactNumber}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.contactNumber`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.contactNumber &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.contactNumber && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.contactNumber}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Email</label>
                                                                    <input
                                                                        name="email"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.email}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.email`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.email &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.email && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.email}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Shift Timings</label>
                                                                    <input
                                                                        name="shiftTimings"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.shiftTimings}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.shiftTimings`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.shiftTimings &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.shiftTimings && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.shiftTimings}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Date</label>
                                                                    <div className='datetimes'>
                                                                        <DateFild
                                                                            value={values.statements[index].witnessStatementIssuer.date}
                                                                            onChange={(date) => setFieldValue(`statements[${index}].witnessStatementIssuer.date`, date)}
                                                                        />
                                                                    </div>
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.date &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.date && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.date}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Signature</label>
                                                                    <input
                                                                        name="signature"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.signature}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.signature`, e.target.value)}

                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.signature &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.signature && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.signature}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="form-group">
                                                                    <label>Statement Issuer</label>
                                                                    <input
                                                                        name="statementIssuer"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={statement.witnessStatementIssuer.statementIssuer}
                                                                        onChange={(e) => setFieldValue(`statements[${index}].witnessStatementIssuer.statementIssuer`, e.target.value)}
                                                                    />
                                                                    {errors?.statements?.[index]?.witnessStatementIssuer?.statementIssuer &&
                                                                        touched?.statements?.[index]?.witnessStatementIssuer?.statementIssuer && (
                                                                            <p className="errormsg">{errors.statements[index].witnessStatementIssuer.statementIssuer}</p>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            ))}
                            <div className="button-boxs grid pb-2">
                                <button type='submit' className='btn btn-orange'>Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default StatementForms